<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

              <v-card v-if="selected.node.children !== undefined && selected.node.children.length > 0"
                flat
                :color="set_color_rgb_soft"
                class="pa-4 pt-3 mt-4"
                style="border-radius: 10px; border: 2px dashed #e0e0e0;">
                <div
                  class="body-2 orange--text font-italic line-text-first">
                  Jika Anda menghapus data yang Anda pilih, maka sub data juga akan dihapus.
                </div>
              </v-card>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-center">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text"
                :disabled="process.delete"
                :loading="process.delete"
                @click="deletes()">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text"
                :disabled="process.delete"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12"
              md="3">
              <v-card
                to="/unit/structure"
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="28"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="amanata"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-3"
                      style="font-weight: 600;">
                      Struktur Pegawai
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="9">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <v-spacer />

                  <div
                    class="d-flex align-center justify-end">
                    <v-btn
                      @click="zoomIn"
                      color="#4B4B4B"
                      fab
                      width="36"
                      height="36"
                      elevation="0"
                      style="border-radius: 10px 0px 0px 10px; border-right: 1px solid #FFFFFF;">
                      <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                    </v-btn>

                    <v-btn
                      @click="zoomOut"
                      color="#4B4B4B"
                      fab
                      width="36"
                      height="36"
                      elevation="0"
                      style="border-radius: 0px 10px 10px 0px; border-left: 1px solid #FFFFFF;">
                      <v-icon color="white">mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="3">
              <v-btn
                :to="`/unit/structure/officer/regulation/${$route.params.id}`"
                color="#E5E7EB"
                elevation="0"
                class="text-capitalize d-flex align-center"
                style="border: 1px solid #374151; border-radius: 10px; width: 190px;">
                <!-- <v-icon>mdi-vector-polyline-edit</v-icon>

                <span
                  class="ml-2">
                  Lihat Peraturan Unit
                </span> -->

                Lihat Peraturan Unit
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              md="9">
              <div
                class="d-flex align-center justify-end">
                <div>
                  <span>
                    Total Pegawai:
                  </span>

                  <span
                    class="font-weight-bold black--text">
                    {{ count.user }}
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; height: calc(100vh - 242px); overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <div 
                    id="tree"
                    @mousewheel="deltaZoom">
                    <vue-tree
                      ref="tree"
                      linkStyle="straight"
                      direction="vertical"
                      :dataset="list"
                      :config="{ nodeWidth: 350, nodeHeight: 100, levelHeight: 250 }"
                      :collapse-enabled="true"
                      style="width: 100%; height: calc(100vh - 278px);">
                      <template v-slot:node="{ node, collapsed }">
                        <v-card
                          flat
                          min-width="250"
                          :class="collapsed ? '' : ''"
                          style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px; border-radius: 10px;"
                          :style="`border: 2px dashed ${set_color};`">
                          <v-card-text
                            class="pa-3 py-1"
                            style="height: 90px;">
                            <v-list
                              dense
                              style="background: transparent;">
                              <v-list-item
                                class="px-3">
                                <v-list-item-avatar 
                                  class="mr-3 mt-2"
                                  size="40"
                                  color="#FFFFFF"
                                  style="border: 2px solid #FFFFFF;"
                                  :style="`box-shadow: rgba(${set_color_rgb_custom}, 0.17) 0px -23px 25px 0px inset, rgba(${set_color_rgb_custom}, 0.15) 0px -36px 30px 0px inset, rgba(${set_color_rgb_custom}, 0.1) 0px -79px 40px 0px inset, rgba(${set_color_rgb_custom}, 0.06) 0px 2px 1px, rgba(${set_color_rgb_custom}, 0.09) 0px 4px 2px, rgba(${set_color_rgb_custom}, 0.09) 0px 8px 4px, rgba(${set_color_rgb_custom}, 0.09) 0px 16px 8px, rgba(${set_color_rgb_custom}, 0.09) 0px 32px 16px;`">
                                  <v-img 
                                    width="100%"
                                    height="100%"
                                    alt="amanata" 
                                    :src="node.image_url !== '' ? node.image_url : require('@/assets/image/member_default.png')"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-list-item-avatar>

                                <v-list-item-content
                                  style="max-width: 150px;">
                                  <div
                                    class="body-2 font-weight-bold black--text three-line text-capitalize mb-1">
                                    {{ node.name }}
                                  </div>

                                  <div
                                    class="body-2 black--text"
                                    style="opacity: 60%;">
                                    {{ node.position_title }}
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card-text>

                          <v-card-text
                            class="pa-0"
                            style="position: relative; bottom: -17px;">
                            <v-row
                              align="center"
                              justify="center">
                              <v-col v-if="user.role !== 'viewer'"
                                cols="2"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toAdd(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      style="border-radius: 8px 0px 0px 8px;">
                                      <v-icon small color="white">mdi-plus-circle-multiple-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Tambah
                                  </span>
                                </v-tooltip>
                              </v-col>

                              <v-col v-if="user.role !== 'viewer'"
                                cols="2"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toEdit(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      style="border-radius: 0px; border-left: 1px solid #FFFFFF;">
                                      <v-icon small color="white">mdi-circle-edit-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Ubah
                                  </span>
                                </v-tooltip>
                              </v-col>

                              <v-col v-if="user.role !== 'viewer'"
                                cols="2"
                                class="pa-0">
                                <v-tooltip 
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click.stop="toDelete(node, $event)"

                                      v-bind="attrs"
                                      v-on="on"

                                      block
                                      :color="set_color"
                                      elevation="0"
                                      class="px-0"
                                      style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #FFFFFF;">
                                      <v-icon small color="white">mdi-delete-circle-outline</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Hapus
                                  </span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </template>
                    </vue-tree>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import VueTree from "@ssthouse/vue-tree-chart";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,

          delete: false
        },

        selected: {
          node: {},
          delete: []
        },

        unit: [],

        list: [],

        count: {
          user: 0
        },

        process: {
          load: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      VueTree
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_custom () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `${r}, ${g}, ${b}`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+70}, ${g+91}, ${b+34})`
      }
    },
    mounted () {
      this.fetch()

      this.fetchUser()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          position_unit_id: this.$route.params.id
        }

        await get('admin/user/position', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.list = this.changeData(res.results.data)
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.position_par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.position_id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      deltaZoom(event) {
        if (event.deltaY < 0) {
          this.$refs.tree.zoomIn()
        } else {
          this.$refs.tree.zoomOut()
        }
      },

      zoomIn () {
        this.$refs.tree.zoomIn()
      },
      zoomOut () {
        this.$refs.tree.zoomOut()
      },

      async fetchUser () {
        let params = {
          unit_id: this.$route.params.id
        }

        await get('admin/user/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.count.user = res.results.pagination.total_data
          }
        })
      },

      toAdd(node, event) {
        this.$router.push({ path: '/unit/structure/officer/user/add', query: { unit_id: node.unit_id, unit_name: node.unit_name, position_id: node.position_id, position_title: node.position_title }})
      },

      toEdit(node, event) {
        this.$router.push({ path: `/unit/structure/officer/user/edit/${node.id}`, query: { unit_id: node.unit_id, unit_name: node.unit_name, position_id: node.position_id, position_title: node.position_title }})
      },

      toDelete(node, event) {
        this.selected.delete = []

        this.selected.node = node

        this.selected.delete.push(parseInt(node.id))

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/user/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false

            this.selected.node = {}
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()

            this.fetchUser()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>